<template>
	<div id="customCard" class="customCard">
		<h2>Title</h2>
		<img src="/static/img/placeholder.png" class="img-fluid" />
		<div class="cardActions">
    		<button class="btn btn-default btn-block">Read more &rarr;</button>
    	</div>
    </div>
</template>

<script>
    export default {
      name: 'custom-card'
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/cards/Custom.vue